<script>
import Button from "@/components/atoms/button";

export default {
  name: "ConnexionRequired",
  components: {
    Button
  },
  emits: ["askLogin"]
};
</script>

<template>
  <div>
    <h2 class="u-font-secondary u-font-24 u-font-700 u-color-primary u-text-center u-mb-sm">
      Identification requise
    </h2>
    <p class="u-font-15 u-text-center u-mb-sm u-font-16@sm">
      Merci de vous connecter pour<br>
      accéder à cette fonctionnalité
    </p>
    <div class="u-mt-lg u-mb-lg u-text-center">
      <Button
        variant="secondary"
        radius="full"
        size="lg"
        @click="$emit('askLogin')"
      >
        Je m’identifie
      </Button>
    </div>
  </div>
</template>
